import { useContext, useState } from "react";
import { DrawerContext } from "../../../../store/DrawerContext/DrawerContext";
import { Card, Divider, Drawer, Image, Modal, Tag } from "antd";
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import { defaultFormat } from "../../../../common/utils/formatDate";
import { POSTTYPES } from "../../../../common/constants/postTypes";
import { CheckCircleFilled, CheckCircleOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { authFetch } from "../../../../common/request/authFetch";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import moment from "moment";
import { DrawerPanelTitle, drawerPanelStyles } from "../../../pages/common/Drawers/DrawerPanelTitle";

export const PostsDrawer = () => {

    const { t } = useTranslation();
    const { postsDrawer, setPostsDrawer } = useContext(DrawerContext);
    const { projectGroup } = useAuth();
    const [location, setLocation] = useState<any>();
    const [posts, setPosts] = useState([]);    

    const [updateData, setUpdateData] = useState(false);

    useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${postsDrawer}/postsByLocal`, {}, [],
    (data: any) => {
        setLocation(data.location);
        setPosts(data.posts);
    });
   
    const deletePost = async(value: any) => {
        await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/locations?locationsIds=${value.name}` , { method: 'DELETE'}).then(()=>{
            setUpdateData(!updateData)
        })
    }

    return (
        <>
            {postsDrawer && (
                <Drawer
                    placement="right"
                    width={'45%'}
                    open={postsDrawer != null}
                    onClose={() => setPostsDrawer(null)}
                    {...drawerPanelStyles}
                    title={
                        <DrawerPanelTitle
                            title="Publicaciones"
                            location={location}
                        />
                    }>                    

                    {posts.map((p: any) => <div style={{ margin: '20px 45px' }}>
                        <div style={{ fontSize: '16px', display: 'block' }}>
                            {
                                p?.mediaItemsURL?.length ?
                                p?.mediaItemsURL?.map((googleUrl: string) => {
                                    return (<Image width={'100%'} src={googleUrl} preview={false} style={{ borderRadius: '20px 20px 0px 0px', display: 'inline' }} />)
                                })
                                :
                                <div style={{height: '50px', background: '#F4F7FA', borderRadius: '20px 20px 0px 0px', color:'grey', width: '100%', margin: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid rgba(0, 0, 0, 0.25)', borderBottom: 'none'}}>Sin foto</div>
                            }
                        </div>
                        <div style={{ padding: '15px', textAlign: 'justify', background: 'white', color: 'rgba(0, 0, 0, 0.5)', border: '1px solid rgba(0, 0, 0, 0.25)' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                                <b style={{color:'green'}}><CheckCircleFilled/> {moment(p?.createTime).format('ll')}</b>
                                <Tag style={{ borderRadius: '20px' }}>{POSTTYPES[p?.topicType]}</Tag>
                            </div>
                            <p>{p?.summary}</p>

                            <div style={{display:'flex', justifyContent:'space-between', margin:'0px 10px'}}>
                                <a onClick={
                                        () => {
                                            Modal.confirm({
                                                title: t('locals.drawer.tabs.photo.delete.title'),
                                                okText: t('dictionary.confirm'),
                                                cancelText: t('dictionary.cancel'),
                                                onOk: () => deletePost(p),
                                            });
                                        }
                                    }>
                                    {t('dictionary.delete')}
                                </a>
                                <div style={{ fontWeight: 'bold' }}><a target={'_blank'} href={p?.searchUrl}>{t('dictionary.viewOnGoogle')} {'>>>'}</a></div>
                            </div>                            
                        </div>
                        
                    </div>)}
                </Drawer>
            )}
        </>
    );
};
